<template>
    <div class="container-fluid">
        <b-form v-on:submit.prevent="$_startCacheSearch">
            <h1>{{$t('menuItemSearchInCache')}}</h1>
            <br />
            <span>{{$t('searchInCachePageText')}}</span>
            <br />
            <br />
            <!-- Card for searching in the SearchCache-->
            <b-card no-body footer-tag="footer">
                <b-card-body>
                    <!-- Searchterm input -->
                    <label class=""
                           for="searchTerm">
                        {{$t('searchTerm')}}
                    </label>
                    <div class="col-12 input-group pl-0">
                        <base-input type="text"
                                    id="searchTerm"
                                    v-model="searchTerm"
                                    maxlength="20"
                                    :autofocus="true">
                        </base-input>
                        <br />
                        <!-- Start search button -->
                        <base-button :id="`searchCache`"
                                     variant="primary"
                                     type="submit"
                                     :disabled="$_startCacheSearchButtonDisabled()"
                                     :text="$t('searchCacheDatabase')"
                                     class="ml-2">
                        </base-button>
                    </div>
                    <br />
                    <!-- Results area -->
                    <x-textarea name="searchResults"
                                :text="$t('results')"
                                plaintext
                                :rows="10"
                                v-model="resultText"
                                :hasResizeHandle="true">
                    </x-textarea>
                </b-card-body>
                <template v-slot:footer>
                    <span>{{$t('state')}}: {{statusCacheSearch}}</span>
                </template>
            </b-card>
        </b-form>
    </div>
</template>

<script>
    import XTextarea from '../../components/BaseComponents/x-textarea.vue';
    import BaseButton from '../../components/BaseComponents/base-button.vue';
    import BaseInput from '../../components/BaseComponents/base-input.vue';
    import { nprogress } from '../../services/utilities';

    export default {
        components: {
            'base-button': BaseButton,
            'x-textarea': XTextarea,
            'base-input': BaseInput
        },

        data() {
            return {
                'searchTerm': '',
                'resultText': '',
                'statusCacheSearch': this.$t('statusNoRequestSent'),
            };
        },

        methods: {
            async $_startCacheSearch() {
                this.statusCacheSearch = this.$t('statusRequestSent');
                this.resultText = '';

                // Catch empty input
                if (this.searchTerm.length === 0) {
                    return;
                }

                nprogress.start();
                await this.$store.dispatch('useApiData', {
                    name: 'QuerySearchCache',
                    parameters: {
                        organizationId: this.$store.getters.userInfo.organizationId,
                        searchTerm: this.searchTerm
                     }
                })
                    .then((result) => {
                    // Success
                    if (result.data) {
                        // Read results into formatted string
                        let searchCacheResults = '';
                        result.data.forEach(function (searchResult) {
                            const searchResultString = JSON.stringify(searchResult);
                            searchCacheResults += searchResultString;
                            searchCacheResults += '\n\n';
                        });
                        this.resultText = searchCacheResults;
                        this.statusCacheSearch = this.$t('statusSearchInCacheRequestFinished');
                    } else {
                        this.statusCacheSearch = this.$t('statusSearchInCacheRequestFailed');
                    }
                    nprogress.done();
                }, (reason) => {
                    nprogress.done();
                    // Error
                    this.statusCacheSearch = this.$t('statusSearchInCacheRequestFailed');
                    this.showToast({
                        title: this.$t('searchCacheFailed'),
                        message: this.$t('searchCacheFailedError', [`${reason.data.message}`]),
                        variant: 'danger',
                        autoHideDelay: 5000,
                    });
                });
            },
            $_startCacheSearchButtonDisabled() {
                return (this.searchTerm.length <= 0);
            }
        }
    };
</script>
